import './App.css';
import React, { Suspense, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer'

import jwt_decode from 'jwt-decode';
import setAuthToken from './utils/setAuthToken';
import { currentUser, logoutUserWithoutConfirm } from './reducers/auth';
import axios from 'axios'
import { API_URL } from './Globals/constant'
import Loader from "./common/Spinner"
import { listSetting } from './reducers/setting';
import { Provider } from 'react-redux';
import store from './store';
import ScrollToTop from './common/ScrollToTop';

import { getFeaturedListing } from './reducers/listing';
const Landing = React.lazy(() => import('./pages/home/Landing'));
const AboutUS = React.lazy(() => import('./pages/home/AboutUs'))


const FAQ = React.lazy(() => import('./pages/home/FAQ'))
const KnowYourUser = React.lazy(() => import('./pages/home/KnowYourUserInvestor'))
const KnowYourFarmer = React.lazy(() => import('./pages/home/KnowYourFarmer'))
const KnowYourSupplyChain = React.lazy(() => import('./pages/home/KnowYourSupplyChain'))
const KnowYourPartner = React.lazy(() => import('./pages/home/KnowYourPartner'))
const TermsAndCondition = React.lazy(() => import('./pages/home/TermsAndConditions'))
const ListingTerms = React.lazy(() => import('./pages/home/ListingTerms'))
const PrivacyPolicy = React.lazy(() => import('./pages/home/PrivacyPolicy'))
const CookiePolicy = React.lazy(() => import('./pages/home/CookiePolicy'))
const ITSecurityMeasuresPolicy = React.lazy(() => import('./pages/home/ITSecurityMeasuresPolicy'))
const CyberSecurityMeasures = React.lazy(() => import('./pages/home/CyberSecurityMeasures'))
const RiskAcknowledgement = React.lazy(() => import('.//pages/home/RiskAcknowledgmentPage'))
const WebsiteDisclosure = React.lazy(() => import('./pages/home/WebsiteDisclosurePage'))
const Team = React.lazy(() => import('./pages/home/Team'))
const Contact = React.lazy(() => import('./pages/home/Contact'))
const ComingSoon = React.lazy(() => import('./pages/home/ComingSoon'))
const Certificate = React.lazy(() => import('./pages/home/Certificate'))
const AccountDeletion = React.lazy(() => import('./pages/home/AccountDeletion'))

axios.defaults.baseURL = API_URL;






function App() {







  return (
    <Provider store={store}>
      <Router
        exact
        path="/"
      >
        <ScrollToTop />
        <Suspense fallback={<Loader />}>
          <Routes>

            <Route path="/" element={<Landing />} index exact />



            {/* USER AUTHTICATION ROUTES END*/}


            <Route path="/aboutus" exact element={<AboutUS />} />
            <Route path="faq" exact element={<FAQ />} />
            <Route path="/know-your-user-investor" exact element={<KnowYourUser />} />
            <Route path="/know-your-farmer" exact element={<KnowYourFarmer />} />
            <Route path="/know-your-supply-chain" exact element={<KnowYourSupplyChain />} />
            <Route path="/know-your-partner" exact element={<KnowYourPartner />} />
            <Route path="/terms-and-conditions" exact element={<TermsAndCondition />} />
            <Route path="/listing-terms-and-conditions" exact element={<ListingTerms />} />
            <Route path="/help/account-deletion" exact element={<AccountDeletion />} />


            <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" exact element={<CookiePolicy />} />
            <Route path="/it-policy" exact element={<ITSecurityMeasuresPolicy />} />
            <Route path="/cyber-policy" exact element={<CyberSecurityMeasures />} />
            <Route path="/risk-acknowledgement" exact element={<RiskAcknowledgement />} />
            <Route path="/website-disclosure" exact element={<WebsiteDisclosure />} />
            <Route path="/team" exact element={<Team />} />
            <Route path="/contact" exact element={<Contact />} />

            <Route path="/coming-soon" exact element={<ComingSoon />} />

            <Route path="/certificate" exact element={<Certificate />} />


            {/* <Route element={<Error />} /> */}



          </Routes>
        </Suspense>
      </Router>

    </Provider>
  )

}

export default App;
